<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>
        水防災オープンデータ配信システム 契約者操作画面
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid" @submit.prevent>
        <v-text-field
          v-model="userId"
          :rules="loginRules"
          label="ユーザID"
          required
          class="ml-3 mr-3"
          prepend-icon="person"
          maxlength="100"
        />
        <v-text-field
          v-model="password"
          type="password"
          label="パスワード"
          required
          class="ml-3 mr-3"
          prepend-icon="lock"
          @keypress.enter="login"
          maxlength="100"
        />
      </v-form>
      <v-snackbar v-model="snackbar" top color="error">
        {{ loginErrorMessage }}
      </v-snackbar>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="login" color="primary" :disabled="!valid">
        ログイン
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import loginModule from "../../store/LoginModule";
import { Component, Vue } from "vue-property-decorator";
import { message } from "../../config/config";
import Axios from "axios";

@Component
export default class Login extends Vue {
  valid = false;

  userId = "";
  password = "";

  snackbar = false;
  loginErrorMessage = "";

  get loginRules() {
    return [
      (v: string) =>
        !!v || message.getMessageAndReplace("MSG001", "ログインID"),
    ];
  }

  async login() {
    if (!this.valid) {
      return;
    }

    let result: boolean | undefined;
    try {
      result = await loginModule.login({
        userId: this.userId,
        password: this.password,
      });
    } catch (error) {
      if (error instanceof Error) {
        if (error.message === "401") {
          // 認証失敗
          this.loginErrorMessage = message.getMessage("MSG002");
          this.snackbar = true;
        } else {
          // 運用上起こってはいけないエラー
          await this.$router.push({ name: error.message });
        }
        return;
      }
    }
    if (result) {
      await this.$router.push({ name: "Menu" });
    }
  }
}
</script>
<style lang="scss" scoped></style>
